module.exports = __webpack_public_path__ + "static/media/Flag-Sudan.fb68daf2.svg";